import { Box, Card, CardBody, Flex, Grid, GridItem, Icon, Separator, Text, Stack } from '@chakra-ui/react';
import React from 'react';
import ContentCard from '../../../components/layout/ContentCard';
import MailboxGraph from '../components/MailboxGraph';
import ProcessingProgressSwitch from '../components/ProcessingProgressSwitch';
import DeleteMailboxDialog from '../modals/DeleteMailboxDialog';
import UpdateMailboxDialog from '../modals/UpdateMailboxDialog';
import { IMailbox } from '../types';
import MailboxProcessingStatus from '../components/MailboxProcessingStatus';

interface MailboxCardProps {
    mailbox: IMailbox;
}

const MailboxCard = ({ mailbox }: MailboxCardProps) => {
    const { currentSession, email } = mailbox;
    

    return (
        <ContentCard
            header={
                <Flex alignItems='center' gap={2}>
                    <Card.Title fontSize='sm' flex='1'>Mailbox</Card.Title>
                    <UpdateMailboxDialog mailbox={mailbox} />
                    <DeleteMailboxDialog mailbox={mailbox} />
                </Flex>
            }
            width={380}
        >
            <Stack gap={0}>
                <Text fontSize='xs' fontWeight='bold'>{email}</Text>
                <Text fontSize='xs'>New session started at: {currentSession?.startedAt ? new Date(currentSession?.startedAt)?.toDateString() : '-'}</Text>
                <Box mx={-5}>
                    <MailboxGraph width={370} mailboxSession={currentSession ?? {}}/>
                </Box>
                <Card.Root width={'100%'}>
                    <Card.Body p={2}>
                        <MailboxProcessingStatus
                            mailbox={mailbox}
                        />
                    </Card.Body>
                </Card.Root>
            </Stack>
        </ContentCard>
    )
}

export default MailboxCard;